import type { VehicleState, VehicleRepository } from './RepositoryInterfaces.js';

export class InMemoryVehicleRepository implements VehicleRepository {
  private vehicles: Map<string, VehicleState> = new Map();

  async findAll(): Promise<VehicleState[]> {
    return Array.from(this.vehicles.values());
  }

  async findById(id: string): Promise<VehicleState | undefined> {
    return this.vehicles.get(id);
  }

  async findByProjectId(projectId: string): Promise<VehicleState[]> {
    return (await this.findAll()).filter((v) => v.projectId === projectId);
  }

  async save(vehicle: VehicleState): Promise<VehicleState> {
    this.vehicles.set(vehicle.id, vehicle);
    return vehicle;
  }

  async delete(id: string): Promise<void> {
    this.vehicles.delete(id);
  }

  seed(vehicles: VehicleState[]): void {
    vehicles.forEach((v) => this.vehicles.set(v.id, v));
  }
}

export const createInMemoryVehicleRepository = (): InMemoryVehicleRepository => new InMemoryVehicleRepository();
